<template>
  <div>
    <Header></Header>
    <div class="background">
      <div class="details" v-for="(list,index) in lists" :key="index">
        <!-- 微导航 -->
        <div class="wnav">
          <span>课程体系</span> >
          <router-link to="/course">精选课程</router-link>>
          <span class="gengduo">课程详情</span>
        </div>
        <!-- 头部 -->
        <div class="title">
          <div class="img">
            <img class="tx" :src="list.image" alt />
          </div>
          <div class="right">
            <p class="bt">{{list.name}}</p>
            <p class="sj">{{list.playtimes}}丨{{list.sales}}人学习</p>
            <p class="jg" v-if="list.price==0.00">免费</p>
            <p class="jg" v-else>￥{{list.price}}</p>
            <div class="gm">
              <p class="btn" v-if="list.pay==0" @click="gopay(list.id)">购买课程</p>
              <p class="btn" v-else @click="goxuexi()">
                <img src="../assets/img/bff.png" alt />
                <span>开始学习</span>
              </p>
              <div class="tb">
                <img v-if="collection1==0" @click="shoucang(1)" src="../assets/img/souc_n.png" alt />
                <img v-else @click="shoucang(0)" src="../assets/img/souc_s.png" alt />
                <img @click="shareToQQ" src="../assets/img/fx.png" alt />
              </div>
            </div>
          </div>
        </div>
        <!-- 身体 -->
        <div class="st">
          <!-- 分享 -->
          <div class="fenxiang" v-show="list.pay==1">
            <img class="fx" @click="fx()" src="../assets/img/wechat.png" alt />
            <img class="fx" @click="shareToQQ" src="../assets/img/qq.png" alt />
          </div>
          <div class="left">
            <ul class="title1">
              <li
                class="title1-name"
                v-for="(tab,index) in tabs"
                :key="index"
                @click="toggle(index,tab.view,list)"
                :class="{active:active==index}"
              >{{tab.type}}</li>
            </ul>
            <div v-show="currentView==`tab1`">
              <div class="tab1">
                <!-- <div class="summarize">课程概述：</div> -->
                <div class="summarize" v-html="list.intro">
                  <br />
                  <br />
                </div>
                <img :src="list.content_image" alt />
              </div>
            </div>
            <div
              v-show="currentView==`tab2`"
              v-for="(list1,index) in list.chapter_list"
              :key="index"
            >
              <div class="Catalog">
                <div class="list">{{list1.name}}</div>
                <ul>
                  <li @click="gobf(list2)" v-for="(list2,index) in list1.video_list" :key="index">
                    <span>{{list2.name}}</span>
                    <span>
                      {{list2.playtime_time}}
                      <img src="../assets/img/video.png" alt />
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="right-top">
              <div class="lecturer">
                <div class="js">课程讲师</div>
                <div class="name" @click="gotdetails(list.teacher_id)">
                  <img :src="list.teacher_data.avatar" alt />
                  <div class="center">
                    <span class="center-name">{{list.teacher_data.nickname}}</span>
                    <span class="center-c">{{list.teacher_data.the_title}}</span>
                  </div>
                  <span class="jiantou">></span>
                </div>
              </div>
            </div>
            <div class="right-bom">
              <div class="comment">课程评论（{{pinglunnum}}）</div>
              <div class="message" v-if="list.pay==1">
                <textarea
                  v-model="pingjia"
                  placeholder="发表您的评价…"
                  id="memo"
                  style="min-height: 120px;min-width: 282px;max-height: 120px; max-width: 282px;"
                ></textarea>
              </div>
              <div class="message" v-else>
                <textarea
                  class="goumaai"
                  v-model="pingjia"
                  placeholder="购买课程后才可评价"
                  id="memo"
                  style="min-height: 120px;min-width: 282px;max-height: 120px; max-width: 282px;"
                ></textarea>
              </div>
              <div class="btn1" @click="add_evaluate" v-if="list.pay==1">发表评论</div>
              <div class="btn" v-else>发表评论</div>
              <div class="liuyan" v-for="(pl,index) in pinglun" :key="index">
                <div class="liuyan-details">
                  <img :src="pl.user_image" alt />
                  <div class="center">
                    <span class="center-name">{{pl.user_name}}</span>
                    <br />
                    <span class="center-time">{{pl.createtime}}</span>
                  </div>
                </div>
                <div class="pl">{{pl.name}}</div>
              </div>
              <div style="text-align:center;margin-bottom:14px;">
                <el-pagination
                  small
                  background
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-size="pageSize"
                  layout=" prev, pager, next"
                  :total="totalNum"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="ewm" id="qrCode" ref="qrCodeDiv">下载二维码分享</div>
    </div>
    <!-- 绑定验证手机号 -->
    <div>
      <div class="login" v-show="popup==2">
        <img src="../assets/img/dlbg.png" alt />
        <div class="right">
          <img class="close" src="../assets/img/xx.png" alt @click="closepopup" />
          <div class="phone">绑定手机号</div>
          <input type="text" class="int" v-model="phone1" placeholder="请输入手机号" />
          <div class="Password">验证码</div>
          <div class="yzm">
            <input type="text" class="yzm-i" v-model="code2" placeholder="请输入验证码" />
            <div class="yzm-btn" v-show="show" @click="getyzm">获取验证码</div>
            <div class="yzm-btn djs" v-show="!show">{{count}}s后获取</div>
          </div>
          <div class="phone">密码</div>
          <input type="password" class="int" v-model="password" placeholder="请输入密码" />
          <div class="Password">邀请码（选填）</div>
          <input type="text" v-model="invitation" class="int" placeholder="请输入邀请码" />
          <div class="btn" @click="bangding_phone()">立即绑定</div>
        </div>
      </div>
    </div>
    <!--这里是半透明背景层-->
    <div class="over" v-show="popup!=1"></div>
    <Footer></Footer>
    <Login v-show="popup==3"></Login>
  </div>
</template>

<script>
import Header from "./header";
import Footer from "./footer";
import QRCode from "qrcodejs2";
import Login from "./popup/login";
export default {
  // 无感刷新引入
  inject: ["reload"],
  name: "details",
  data() {
    return {
      active: 0,
      currentView: "tab1",
      tabs: [
        {
          type: "课程详情",
          view: "tab1",
        },
        {
          type: "课程介绍",
          view: "tab2",
        },
      ],
      lists: [],
      pinglun: [],
      good: "",
      pinglunnum: "",
      pingjia: "", //评论
      collection1: "", //收藏
      currentPage: 1, //默认显示第一页
      pageSize: 6, //默认每页显示条
      totalNum: 0, //总页数
      ewm: false,
      uid: "",
      popup: "1",
      phone1: "", //手机号
      code2: "", //验证码
      password: "", //密码
      invitation: "", //邀请码
      show: true,
      count: "0", //倒计时
      timer: null,
      code1: "",
    };
  },
  created() {
    this.id = this.$route.query.id;
    if (JSON.parse(sessionStorage.getItem("data"))) {
      this.uid = JSON.parse(sessionStorage.getItem("data")).id;
    }
  },
  methods: {
    // 微信生成二维码
    bindQRCode: function () {
      new QRCode(this.$refs.qrCodeDiv, {
        text: window.location.href,
        width: 160,
        height: 160,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      });
    },
    //分享到QQ好友(PC端可用)
    shareToQQ() {
      //此处分享链接内无法携带图片
      const share = {
        title: "知会教育",
        desc: "知会教育pc端QQ分享",
        share_url: window.location.href,
      };
      location.replace(
        "https://connect.qq.com/widget/shareqq/index.html?url=" +
          encodeURIComponent(share.share_url) +
          "&title=" +
          share.title +
          "&desc=" +
          share.desc
      );
    },
    fx() {
      this.ewm = !this.ewm;
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val; //动态改变
      this.evaluate_list();
    },
    // 验证码获取
    async getyzm() {
      if (
        !/^((1[3,5,8][0-9])|(14[5,7])|(17[0,6,7,8,5])|(19[7]))\d{8}$/.test(
          this.phone1
        )
      ) {
        this.$confirm("手机号格式错误")
          .then((_) => {
            done();
          })
          .catch((_) => {});
        return false;
      } else {
        const TIME_COUNT = 60;
        var phone1 = this.phone1;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
        await this.$service.home
          .getyzm({
            phone: phone1,
            type: 1,
          })
          .then((res) => {
            console.log(res);
            if (res.data) {
              if (res.data.code == 200) {
                this.code1 = res.data.content;
              }
            }
            if (res.err) {
              if (res.err.data.code == 201) {
                this.$confirm(res.err.data.msg)
                  .then((_) => {
                    done();
                  })
                  .catch((_) => {});
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    //  tab切换
    toggle(i, v, l) {
      // console.log(l.pay);
      if (l.pay == 0) {
        this.$confirm("请先购买哦~")
          .then((_) => {
            done();
          })
          .catch((_) => {});
      } else {
        this.active = i;
        this.currentView = v;
      }
    },
    open1() {
      this.$notify({
        title: "成功",
        message: "评论成功",
        type: "success",
      });
    },
    // 购买课程
    async gopay(id) {
      if (JSON.parse(sessionStorage.getItem("data"))) {
        var if_phone = sessionStorage.getItem("if_phone");
        if (if_phone == 1) {
          await this.$service.home
            .course_pay({ id: id, uid: this.uid })
            .then((res) => {
              // console.log(res);
              if (res.data.code == 200) {
                var money = res.data.content.money;
                var order_id = res.data.content.order_id;
                this.$router.push({
                  path: "/pay",
                  query: {
                    id: id,
                    money: money,
                    order_id: order_id,
                  },
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.popup = 2;
        }
      } else {
        this.popup = 3;
      }
    },
    // 开始学习
    goxuexi() {
      if (JSON.parse(sessionStorage.getItem("data"))) {
        this.$router.push({
          path: "/course_system",
          query: {
            id: this.id,
          },
        });
      } else {
        this.popup = 3;
      }
    },
    // 课程详情
    async course_detail() {
      await this.$service.home
        .course_detail({ course_id: this.id, uid: this.uid })
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            var arrs = [];
            arrs.push(res.data.content);
            this.lists = arrs;
            this.collection1 = res.data.content.collection;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //关闭弹窗
    closepopup() {
      this.popup = 1;
      // 页面无感刷新
      this.reload();
    },
    // 课程评论列表
    async evaluate_list() {
      await this.$service.home
        .evaluate_list({
          course_id: this.id,
          page: this.currentPage,
          page_count: this.pageSize,
        })
        .then((res) => {
          // console.log(res.data.content.count);
          if (res.data.code == 200) {
            this.pinglun = res.data.content.list;
            this.pinglunnum = res.data.content.count;
            // 向上取整数
            var totalNum = Math.ceil(res.data.content.count);
            this.totalNum = totalNum;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 添加评论
    async add_evaluate() {
      if (JSON.parse(sessionStorage.getItem("data"))) {
        await this.$service.home
          .add_evaluate({
            course_id: this.id,
            uid: this.uid,
            value: this.pingjia,
          })
          .then((res) => {
            if (res.data.code == 200) {
              this.open1();
              this.evaluate_list();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.popup = 3;
      }
    },

    // 收藏
    async shoucang(i) {
      if (JSON.parse(sessionStorage.getItem("data"))) {
        var id = JSON.parse(sessionStorage.getItem("data"));
        await this.$service.home
          .collection({
            course_id: this.id,
            uid: id.id,
            type: i,
          })
          .then((res) => {
            // console.log(res);
            if (res.data.code == 200) {
              this.$notify({
                title: "成功",
                message: "成功",
                type: "success",
              });
              this.course_detail();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.popup = 3;
      }
    },
    // 讲师跳转
    gotdetails(id) {
      // console.log(id);
      this.$router.push({
        path: "/topic_details",
        query: {
          id: id,
        },
      });
    },
    // 介绍课程播放
    gobf(list) {
      if (JSON.parse(sessionStorage.getItem("data"))) {
        console.log(list);
        this.$router.push({
          path: "/course_system",
          query: {
            id: this.id,
            videofile: list.videofile,
            image: list.image,
            name: list.name,
            video_id: list.id,
          },
        });
      } else {
        this.popup = 3;
      }
    },
    // 验证手机号
    async bangding_phone() {
      var phone2 = this.phone1;
      var code = this.code2;
      var  password= this.password;
      if (phone2 && code && password) {
        await this.$service.home
          .ifcode({
            phone: phone2,
            code: code,
          })
          .then((res) => {
            console.log(res);
            if (res.data) {
              if (res.data.code == 200) {
                this.bangding();
              }
            }
            if (res.err) {
              if (res.err.data.code == 201) {
                this.$confirm(res.err.data.msg)
                  .then((_) => {
                    done();
                  })
                  .catch((_) => {});
              }
            }
          })
          .catch((err) => {});
      } else {
        this.$confirm("必填项不能为空哦")
          .then((_) => {
            done();
          })
          .catch((_) => {});
      }
    },
    // 绑定手机号
    async bangding() {
      var id = JSON.parse(sessionStorage.getItem("data"));
      await this.$service.home
        .bangding_phone({
          uid: id.id,
          phone: this.phone1,
          password: this.password,
          invite_code: this.invitation,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$confirm("绑定成功")
              .then((_) => {
                done();
              })
              .catch((_) => {});
              sessionStorage.setItem("if_phone", 1);
            // 页面无感刷新
            this.reload();
          }
        });
    },
  },
  components: {
    Header,
    Footer,
    Login,
  },
  mounted() {
    this.course_detail();
    this.evaluate_list();
    this.$nextTick(function () {
      this.bindQRCode();
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#qrCode {
  position: absolute;
  top: 472px;
  right: 5px;
  text-align: center;
}
a {
  text-decoration: none;
  color: #000;
}
textarea {
  width: 282px;
  height: 120px;
  background: rgba(243, 243, 243, 1);
  border-radius: 10px;
  border: none;
  padding: 10px 0 0 10px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
}
.background {
  position: relative;
  width: 1200px;
}
.background .details {
  width: 1200px;
  margin: 0 auto;
}
/* 微导航 */
.background .details .wnav {
  height: 30px;
  line-height: 40px;
  font-size: 14px;
  margin-bottom: 10px;
}
.background .details .wnav span.gengduo {
  color: rgba(136, 136, 136, 1);
}
/* 头部 */
.background .details .title {
  height: 360px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px solid rgba(237, 237, 237, 1);
  display: flex;
  justify-content: space-around;
}
.background .details .title .img .tx {
  width: 480px;
  height: 320px;
  margin-top: 25px;
}
.background .details .title .right .bt {
  width: 655px;
  height: 60px;
  font-size: 26px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
}
.background .details .title .right .sj {
  height: 24px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
}
.background .details .title .right .jg {
  width: 655px;
  font-size: 36px;
  font-weight: bold;
  color: rgba(255, 83, 91, 1);
  margin: 0;
}
.background .details .title .right .gm {
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
}
.background .details .title .right .gm .btn {
  width: 154px;
  height: 44px;
  background: rgba(23, 117, 239, 1);
  border-radius: 22px;
  font-size: 20px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 44px;
  text-align: center;
}
.background .details .title .right .gm .tb {
  padding-top: 22px;
}
/* 身体 */
.background .details .st {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.background .details .st .fenxiang {
  width: 166px;
  height: 81px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.16);
  display: flex;
  justify-content: space-around;
  position: absolute;
  top: -29px;
  right: 5px;
}
.background .details .st .fenxiang .fx {
  width: 43px;
  height: 35px;
  margin-top: 29px;
}
.background .details .st .left {
  width: 860px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
}
.background .details .st .left .title1 {
  display: flex;
  border-bottom: 1px solid #ededed;
}
.background .details .st .left .title1 .title1-name {
  width: 100px;
  height: 62px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.background .details .st .left .title1 .title1-name.active {
  color: #1775ef;
}
.background .details .st .right {
  width: 324px;
}
.background .details .st .right .right-top {
  width: 324px;
  height: 146px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px solid rgba(237, 237, 237, 1);
  margin-bottom: 16px;
}
.background .details .st .right .right-top .lecturer {
  width: 280px;
  height: 100px;
  margin: 0 auto;
  position: relative;
  top: 50%; /*偏移*/
  transform: translateY(-50%);
}
.background .details .st .right .right-top .lecturer .js {
  font-size: 16px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 20px;
}
.background .details .st .right .right-top .lecturer .name {
  display: flex;
}
.background .details .st .right .right-top .lecturer .name .jiantou {
  margin-left: 108px;
  margin-top: 18px;
}
.background .details .st .right .right-top .lecturer .name img {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  margin-right: 10px;
}
.background .details .st .right .right-top .lecturer .name .center {
  display: inline-flex;
  flex-direction: column;
}
.background
  .details
  .st
  .right
  .right-top
  .lecturer
  .name
  .center
  .center-name {
  font-size: 18px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 25px;
}
.background .details .st .right .right-top .lecturer .name .center .center-c {
  font-size: 14px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 36px;
}
.background .details .st .right .right-bom {
  width: 324px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px solid rgba(237, 237, 237, 1);
}
.background .details .st .right .right-bom .comment {
  font-size: 16px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
  margin: 20px 0 20px 20px;
}
.background .details .st .right .right-bom .message {
  margin: 0 auto;
  width: 282px;
  height: 120px;
  background: rgba(243, 243, 243, 1);
  border-radius: 10px;
  margin-bottom: 16px;
}
.background .details .st .right .right-bom .btn,
.background .details .st .right .right-bom .btn1 {
  width: 282px;
  height: 40px;
  background: #b4b4b4;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 40px;
  text-align: center;
  margin: 0 auto;
  margin-bottom: 30px;
}
.background .details .st .right .right-bom .btn1 {
  background: rgba(23, 117, 239, 1);
}
.background .details .st .right .right-bom .liuyan {
  width: 282px;
  /* height: 140px; */
  border-bottom: 1px solid #ededed;
  margin: 0 auto;
  margin-bottom: 16px;
}
.background .details .st .right .right-bom .liuyan .liuyan-details {
  display: flex;
}
.background
  .details
  .st
  .right
  .right-bom
  .liuyan
  .liuyan-details
  .center
  .center-name {
  font-size: 16px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
  letter-spacing: 1px;
}
.background
  .details
  .st
  .right
  .right-bom
  .liuyan
  .liuyan-details
  .center
  .center-time {
  font-size: 12px;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 18px;
}
.background .details .st .right .right-bom .liuyan .liuyan-details img {
  width: 44px;
  height: 44px;
  border-radius: 50%;
}
.background .details .st .right .right-bom .liuyan .pl {
  font-size: 14px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 24px;
  text-align: justify;
  text-justify: newspaper;
  word-break: break-all;
}
.tab1 {
  width: 555px;
  margin-left: 55px;
}
.tab1 .summarize {
  font-size: 14px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
  margin-bottom: 16px;
}
.tab1 img {
  width: 760px;
  min-height: 828px;
}

.Catalog {
  width: 800px;
  margin-left: 54px;
}
.Catalog .list {
  font-size: 16px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
}
.Catalog ul {
  padding: 0;
}
.Catalog ul li {
  height: 20px;
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
}
.Catalog ul li:hover {
  background: rgba(23, 117, 239, 0.1);
}
/* 绑定手机号 */
.over {
  position: fixed;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  filter: alpha(opacity=50);
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #111111;
}
.login {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  width: 700px;
  height: 420px;
  background: rgba(255, 255, 255, 1);
  display: flex;
}
.login .right {
  margin-left: 62px;
  margin-top: 16px;
}
.login .right .bot {
  display: flex;
  margin-top: 12px;
}
.login .right .bot .fanhui {
  font-size: 12px;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  margin-left: 1px;
}
.login .right .bot img {
  margin-top: 100px;
}
.login .right .bot .fanhui1 {
  font-size: 12px;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  margin-top: 100px;
}
.login .right .bot .bot-r {
  display: flex;
  font-size: 12px;
  font-weight: 500;
  margin-left: 62px;
}
.login .right .bot .ty {
  color: rgba(136, 136, 136, 1);
}
.login .right .bot .xieyi {
  color: #1775ef;
}
.login .right .close {
  margin-left: 306px;
}
.login .right .title {
  font-size: 24px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 22px;
}
.login .right .title1 {
  font-size: 24px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  text-align: center;
  margin-bottom: 22px;
}
.login .right .phone,
.login .right .Password {
  font-size: 14px;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  margin-bottom: 6px;
}
.login .right .btn {
  width: 280px;
  height: 46px;
  background: rgba(23, 117, 239, 1);
  border-radius: 6px;
  text-align: center;
  line-height: 46px;
  color: #ffffff;
  margin-bottom: 10px;
}
.login .right .register1 {
  font-size: 12px;
  font-weight: 500;
  color: rgba(23, 117, 239, 1);
  margin-left: 172px;
}
input::-webkit-input-placeholder {
  padding-left: 10px;
}
.login .right input.int {
  background-color: #f8f8f8;
  width: 280px;
  height: 36px;
  border-radius: 6px;
  border: none;
  margin-bottom: 16px;
}
.login .right .yzm {
  display: flex;
  margin-bottom: 16px;
}
.login .right input.yzm-i {
  width: 168px;
  height: 36px;
  margin-right: 12px;
  background-color: #f8f8f8;
  border-radius: 6px;
  border: none;
}
.login .right .yzm-btn {
  width: 100px;
  height: 36px;
  background: rgba(23, 117, 239, 1);
  border-radius: 6px;
  color: #ffffff;
  font-size: 14px;
  line-height: 36px;
  text-align: center;
}
.login .right .djs {
  background-color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/details.vue